module.exports = __webpack_public_path__ + "assets/hamburger-1b85e9.svg";